<template>
  <div>
    <v-container  style="max-width:700px">
    <v-card flat class="my-12 pa-0" >
      <v-layout row wrap class="mt-4">
        <v-flex  xs12 sm6 md4 v-for="category in categories" :key="category.id" style="padding-right:10px;">
          <v-card
            class="pt-0 mx-0 mb-0 text-xs-center fixed-height rounded-t-xl"
            outlined
            max-width="250px"
            max-height="295.4978px"
            :style="`border:1px solid ${category.color}`"
          >
            <v-img :src="getImgSrc(category.avatar)" style="height:140px;width:250px" />

            <v-card :color="category.color" class="category text-xs-center" >
              <v-card-text class="white--text text-center category">
                <div class="categoryContent" >
                    {{ category.method }} 
                </div>
              </v-card-text>
            </v-card>
          
 
            <v-card-title class="justify-center gray--text text--accent-2 px-0 ">
              <v-card-text class="text-center pa-0">
              <div 
              class="content-4"
              v-for="item in category.categorylist"
                  :key="item.id">
                <v-icon v-text="icon"  size="5px"></v-icon>
                {{ item.title }}
              </div>
              </v-card-text>
            </v-card-title>

          </v-card>
        
        </v-flex>
      </v-layout>

      <v-layout row wrap >
        <v-flex>
          <v-card flat class="heading">
            <span class="heading">
              Value of distributed energy resources (VODER)
            </span>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm9 md6 v-for="resource in resources" :key="resource.id" style="padding-right:10px;">
          <v-card 
          class="pt-0 mx-0 mb-0 text-xs-center fixed-height rounded-t-xl" 
          outlined
          :style="`border:1px solid ${resource.color}`"
           max-width="380px"
           max-height="315.4541px"
          >
            <v-img :src="getImgSrc(resource.avatar)" style="height:139.3293px;width:380px"/>
            <v-card :color="resource.color" class="text-xs-center" >
              <v-card-text class="white--text text-center">
                <div class="mt-2 categoryContent" >
                    {{ resource.title  }} 
                </div>
              </v-card-text>
            </v-card>
            <v-card-text class="text-xs-center text-center">
              <div v-for="benefit in resource.benfts" :key="benefit"  class="content-1">
                <v-icon v-text="icon" size="5px"></v-icon>
                {{ benefit }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
    
      </v-layout>
      <v-col class="text-center py-4" v-if="!isLoggedin">
        <v-btn id = "startBtn" class="mt-8 btn btn-1" router :to="'/login'">Get Started</v-btn>
      </v-col>
   
      <v-flex style="margin-left:-15px">
          <v-card class="mt-8 text-xs-center" flat>
            <v-card flat style="text-align:left" >
            <span class="heading">
              VODER Methodology
            </span>
          </v-card>
            <v-card-text class="content" style="width:105%;margin-left:-10px">
              {{ voderMethodology }}
              <ul class="mt-8">
                <li>Improving utility resource planning</li>
                <li>Informing solar incentive programs</li>
                <li>
                  Establishing an analytical foundation for the determination of
                  feed-in tariffs
                </li>
              </ul>
            </v-card-text>
            <v-btn id = "methodologyBtn" class="ma-4 btn btn-1" @click="downloadPDF()">
              <v-icon left> mdi-arrow-collapse-down </v-icon>Methodology
            </v-btn>
          </v-card>
        </v-flex>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import settingsUtility from "@/utility/settingsUtility";
import webContent from "@/libs/webContent.js";

export default {
  name: "AboutUs",

  data: () => ({
    categories: [],
    resources: [],
    icon: "mdi-checkbox-blank-circle",
    voderMethodology:
      "A methodology that takes a uniform approach to establishing the true value of the electricity produced by distributed energy resources (DER). Value of distributed energy resources methodology (VODER)  takes into consideration the unique nature of distributed energy generation such as solar and energy storage. Unique features include; power generation occurs close to the point of consumption, generation does not require fuel purchase and has significant environmental advantages over fossil fuel powered generation technologies.  These characteristics generally increase the value of DER as they allow utilities to reduce their energy costs,  avoid generation, transmission and distribution capacities costs and reduce the social and environmental impact.  Adapting a VODER methodology represents an opportunity for states and utilities across the country to begin to assess the benefits of distributed generation and better plan for energy investments that provide maximum network and societal benefits. The  VODER methodology can contribute to :",
    defaultSelect: "",
    isLoggedin: null,
  }),
  created() {
    this.defaultSelect = 1;
    this.getCategories();
    this.getResources();
    this.isLoggedin = settingsUtility.methods.getLoginStatus();
  },
  methods: {
    getImgSrc(imageSrc) {
      return imageSrc ? require("../assets/image/" + imageSrc) : "";
    },
    downloadPDF() {
      const url = `${process.env.VUE_APP_BASE_URL}/methodology-documentation/pdf`;
      window.open(url);
    },
    getCategories() {
      this.categories = webContent.getCategoriest();
    },
    getResources() {
      this.resources = webContent.getResources();
    },
  },
};
</script>
<style scoped>

.fixed-height {
  height: 100%;
}
.category{
  /* padding-left: 35pt;
  padding-right: 35pt;
  font-size: 18pt;
  font-weight: 400;
  line-height: 28pt;
  min-height: 70pt; */
  max-height:60px;
  max-width:250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.categoryContent{
  /* margin:auto; 
  margin-top:0pt; */
  font-size:18px;
  font-weight: 300;
}
.heading{
  /* margin-top: 20pt;
  margin-bottom: 20pt;
  text-align: center;
  font-size: 18pt;*/
  text-align: center;
  margin-top: 20pt;
  margin-bottom: 20pt;
  font-weight: 500; 
  color:#2c7154;
  font-size: 25px;
}
 .btn {
  font-size: 24px;
  font-weight: normal;
  color: white;
  width: 180px;
  height: 28px;
  flex: 1 1 auto;
  padding: 30px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  border-radius: 6px;
}
.btn-1 {
  background-image: linear-gradient(
    to right,
    #6bbc56 0%,
    #2fa9d8 55%,
    #2fa9d8 100%
  );
}

.v-btn:not(.v-btn--round).v-size--default {
  font-size: 18px;
  font-weight: normal;
  color: white;
  min-width: 190px;
  height: 28pt;
}
.content-4{
  font-size: 15px;
  padding-left:10px;
  padding-right:10px;
  line-height: 18.05pt;
    color: #5d5e5e;
  /* margin-top: -25pt;
  text-align: left;
  
  font-size: 14pt;
  font-weight: 400;
  color: #5d5e5e;
  line-height: 18.05pt;
  margin-left: -13pt;
  min-width: 1250px; */
}

.content{
  font-size: 15px;
  padding-left:10px;
  padding-right:10px;
  color: #5d5e5e;
  text-align: justify;
  line-height: 18.05pt;
  /* margin-top: -25pt;
  text-align: left;
  
  font-size: 14pt;
  font-weight: 400;
  color: #5d5e5e;
  line-height: 18.05pt;
  margin-left: -13pt;
  min-width: 1250px; */
}
.content-1{
  margin: auto;
  font-size: 15px;
  color: #5d5e5e;
  /* margin-top: auto;
  text-align: center;
  font-size: 14pt;
  font-weight: 400;
  color: #5d5e5e;
  line-height: 18.05pt;
  margin-left: auto;
   min-width: auto; */
}
.categoryContent-2{
  font-size:20px;
  font-weight: 300;
}
</style>